export default {
  // App
  APP: 'app',
  SET_MESSAGE: 'SET_MESSAGE',
  SHOW_BUSY: 'SHOW_BUSY',
  HIDE_BUSY: 'HIDE_BUSY',
  SHOW_INFORMATION: 'SHOW_INFORMATION',
  SHOW_SUCCESS: 'SHOW_SUCCESS',
  SHOW_WARNING: 'SHOW_WARNING',
  SHOW_ERROR: 'SHOW_ERROR',
  HIDE_NOTIFICATION: 'HIDE_NOTIFICATION',

  // User
  USER: 'user',
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  REFRESH_TOKEN: 'REFRESH_TOKEN',
  GET_USER: 'GET_USER',
  SET_USER: 'SET_USER',
  REQUEST_PASSWORD_RESET: 'REQUEST_PASSWORD_RESET',
  RESET_PASSWORD: 'RESET_PASSWORD',
  GET_USERS: 'GET_USERS',
  SET_USERS: 'SET_USERS',
  CREATE_USER: 'CREATE_USER',
  UPDATE_USER: 'UPDATE_USER',
  GET_USER_GDE: 'GET_USER_GDE',
  GET_GROUPS: 'GET_AREAS',
  SET_GROUPS: 'SET_GROUPS',
  GET_AREAS_USER: 'GET_AREAS_USER',
  SETUP_CREATE_USER: 'SETUP_CREATE_USER',
  SETUP_UPDATE_USER: 'SETUP_UPDATE_USER',
  FAST_PASSWORD_RESET: 'FAST_PASSWORD_RESET',
  RESET_MY_PASSWORD: 'RESET_MY_PASSWORD',

  // Invitation
  INVITATION: 'invitation',
  GET_INVITATION_TYPES: 'GET_INVITATION_TYPES',
  SET_INVITATION_TYPES: 'SET_INVITATION_TYPES',
  GET_IDENTIFICATION_TYPES: 'GET_IDENTIFICATION_TYPES',
  SET_IDENTIFICATION_TYPES: 'SET_IDENTIFICATION_TYPES',
  GET_GUESTS: 'GET_GUESTS',
  SET_GUESTS: 'SET_GUESTS',
  CREATE_INVITATION: 'CREATE_INVITATION',
  GET_INVITATIONS: 'GET_INVITATIONS',
  SET_INVITATIONS: 'SET_INVITATIONS',
  GET_INVITATIONS_REPORT: 'GET_INVITATIONS_REPORT',
  SET_INVITATIONS_REPORT: 'SET_INVITATIONS_REPORT',
  SEND_INVITATION: 'SEND_INVITATION',
  CANCEL_INVITATION: 'CANCEL_INVITATION',
  GET_TRANSPORT_TYPES: 'GET_TRANSPORT_TYPES',
  SET_TRANSPORT_TYPES: 'SET_TRANSPORT_TYPES',
  GET_TRANSPORT_COLORS: 'GET_TRANSPORT_COLORS',
  SET_TRANSPORT_COLORS: 'SET_TRANSPORT_COLORS',
  SETUP_INVITATION: 'SETUP_INVITATION',
  GET_SCHEDULE: 'GET_SCHEDULE',
  SET_SCHEDULE: 'SET_SCHEDULE',
  GET_INVITATION: 'GET_INVITATION',
  SET_INVITATION: 'SET_INVITATION',
  GET_AREAS: 'GET_AREAS',
  SET_AREAS: 'SET_AREAS',
  GET_STATUS: 'GET_STATUS',
  SET_STATUS: 'SET_STATUS',
  GET_STATUS_REPORT: 'GET_STATUS_REPORT',
  SETUP_BACKOFFICE: 'SETUP_BACKOFFICE',
  SETUP_BACKOFFICE_REPORT: 'SETUP_BACKOFFICE_REPORT',
  CHECK_IN: 'CHECK_IN',
  CHECK_OUT: 'CHECK_OUT',
  GET_INVITATION_CHECKIN: 'GET_INVITATION_CHECKIN',
  SET_INVITATION_CHECKIN: 'SET_INVITATION_CHECKIN',
  GET_INVITATION_CHECKOUT: 'GET_INVITATION_CHECKOUT',
  SET_INVITATION_CHECKOUT: 'SET_INVITATION_CHECKOUT',

  // Face Detection Listing
  FACE_DETECTION: 'face_detection',
  GET_PROJECTS: 'GET_PROJECTS',
  GET_CONTRACTORS_ACCESS: 'GET_CONTRACTORS_ACCESS',
  SET_PROJECTS: 'SET_PROJECTS',
  SET_CONTRACTORS_ACCESS: 'SET_CONTRACTORS_ACCESS',
  LIST_PROJECTS: 'LIST_PROJECTS',
  LIST_ACCESS: 'LIST_ACCESS',
  SETUP_FACE_CONTROL_ACCESS: 'SETUP_FACE_ACONTROL_ACCESS',

  // Access Logs
  ACCESS_LOGS: 'accessLogs',
  GET_ACCESS_LOGS: 'GET_ACCESS_LOGS',
  SET_ACCESS_LOGS: 'SET_ACCESS_LOGS',
  GET_ACCESS_LOG: 'GET_ACCESS_LOG',
  SET_ACCESS_LOG: 'SET_ACCESS_LOG',

  // Person
  PERSON: 'person',
  SEARCH_BY_IMAGE: 'SEARCH_BY_IMAGE',
  SET_PERSONS: 'SET_PERSONS',
  GET_PERSON: 'GET_PERSON',
  SET_PERSON: 'SET_PERSON',

  // Company
  COMPANY: 'company',
  GET_COMPANIES: 'GET_COMPANIES',
  SET_COMPANIES: 'SET_COMPANIES',

  // Controller
  CONTROLLER: 'controller',
  GET_CONTROLLERS: 'GET_CONTROLLERS',
  SET_CONTROLLERS: 'SET_CONTROLLERS',
  GET_PERSON_PERMISSION: 'GET_PERSON_PERMISSION',
  SET_PERSON_PERMISSION: 'SET_PERSON_PERMISSION',

  // Zone
  ZONE: 'zone',
  GET_ZONES: 'GET_ZONES',
  SET_ZONES: 'SET_ZONES',
};



// WEBPACK FOOTER //
// ./src/types.js